import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import { unitLabel } from '@common/services/unitUtils';
import { withStyles } from 'tss-react/mui';
import { unitResponsesStyles } from './styles';

const VcmUnitCheckModalExtraUnitDetail = ({
  classes,
  extraRemovedUnits,
  extraPresentUnits,
  keepUnitCodes,
  removeUnitCodes,
  onCodeChange
}) => {
  const extraUnitData = [
    ...(extraRemovedUnits || []).map(u => ({ ...u, removed: true })),
    ...(extraPresentUnits || []).map(u => ({ ...u, removed: false })),
  ];

  const rows = extraUnitData.map((unit) => {
    const code = unit.code;
    const description = unit.removed ? 'removed' : 'response data exists';

    return (
      <>
        <Grid size={4}>
          <Typography>{unitLabel(unit)} ({description})</Typography>
        </Grid>
        <Grid size={4} alignItems="stretch">
          <Radio
            className={classes.addExtraUnitsRadio}
            checked={removeUnitCodes.includes(code)}
            onChange={() => { onCodeChange?.(code, 'remove'); }}
          />
        </Grid>
        <Grid size={4} alignItems="stretch">
          <Radio
            className={classes.addExtraUnitsRadio}
            checked={keepUnitCodes.includes(code)}
            onChange={() => { onCodeChange?.(code, 'keep');} }
          />
        </Grid>
      </>
    );
  });

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Typography variant="h6">Extra units on this VCM</Typography>
      </Grid>
      <Grid size={12}>
        <Typography>
          <em>Fully Delete from VCM</em> - Delete all data from the VCM for this unit response as the unit is no longer part of the course.
        </Typography>
        <Typography>
          <em>Keep for now</em> - Use this option if the unit is missing from the system and need to be added back.
        </Typography>
      </Grid>
      <Grid size={4}>
        <Typography><strong>Unit</strong></Typography>
      </Grid>
      <Grid size={4} justify="center">
        <Typography><strong>Fully Delete from VCM</strong></Typography>
      </Grid>
      <Grid size={4} justify="center">
        <Typography><strong>Keep for now</strong></Typography>
      </Grid>
      {rows}
    </Grid>
  );
};

export default withStyles(VcmUnitCheckModalExtraUnitDetail, unitResponsesStyles, {
  withTheme: true
});
